import type {FormEvent} from 'react';
import {usePathname, useRouter, useSearchParams} from 'next/navigation';

import {useCart} from '../../cart/hooks/useCart';
import {getAdapter, searchParamsFromProductConfiguration} from '../configuration';
import type {UnionProductFragment} from '../query';

export function useProductForm(fragment: UnionProductFragment) {
	const router = useRouter();
	const pathname = usePathname();
	const searchParams = useSearchParams();

	const cart = useCart();

	const cartLineId = searchParams.get('cartLineId') ?? null;

	const action = cartLineId ? cart.updateCartAction : cart.addToCartAction;

	const onChange = (e: FormEvent<HTMLFormElement>) => {
		// TODO: Debounce these events to avoid many consecutive reloads

		const adapter = getAdapter(fragment);

		// Update the page search params with the new configuration:
		const formData = new FormData(e.currentTarget);
		const configuration = adapter.parseConfigFromFormData(fragment, formData);

		if (configuration) {
			const params = searchParamsFromProductConfiguration(configuration);

			if (cartLineId) {
				params.set('cartLineId', cartLineId);
			}

			router.replace(`${pathname}?${params.toString()}`, {scroll: false});
		}
	};

	return {
		cart,
		cartLineId,
		action,
		onChange,
	};
}
